import e from "classnames";
const r = (t) => e({
  "w-[120px] mr-[8px] border !border-blue-bold rounded [&>button]:items-center [&>button]:py-[4px] [&>button]:px-[15px] [&>button]:uppercase [&>button]:text-[12px] [&>button]:rounded [&>button>span]:!p-0": !0,
  "[&>button]:bg-surface-primary [&>button]:text-text-link [&>button]:hover:bg-blue-bold [&>button]:hover:text-text-reversed": !t.followActive,
  "[&>button]:flex [&>button]:bg-blue-bold [&>button]:text-text-reversed": t.followActive
}), b = e({
  "text-sm text-red-500 p-1": !0
});
export {
  r as buttonClasses,
  b as errorAlert
};
//# sourceMappingURL=index.es8.js.map
